import _ from 'lodash';
import { mapFields } from './fieldMappers';

export const processFormGroups = (form, config, formId, operationType) => {
  if (!form.groups?.length) return [];

  return form.groups
    .sort((a, b) => (a.order ?? 0) - (b.order ?? 0))
    .map((group) => {
      const fields = mapFields(config, formId, operationType, group.id);
      if (!fields.length) return null;

      const hidden = _.every(fields, { hidden: true });
      return { ...group, fields, hidden };
    })
    .filter(Boolean);
};

export const processUngroupedFields = (config, formId, operationType) => {
  const emptyGroupFields = mapFields(config, formId, operationType);
  if (!emptyGroupFields.length) return null;

  const hidden = _.every(emptyGroupFields, { hidden: true });
  return { fields: emptyGroupFields, hidden };
};
